import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const CloseIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 11 11" fill={fill}>
            <path
                d="M7.69141 5.75L10.4258 3.01562C10.7812 2.6875 10.7812 2.14062 10.4258 1.8125L9.82422 1.21094C9.49609 0.855469 8.94922 0.855469 8.62109 1.21094L5.88672 3.94531L3.125 1.21094C2.79688 0.855469 2.25 0.855469 1.92188 1.21094L1.32031 1.8125C0.964844 2.14062 0.964844 2.6875 1.32031 3.01562L4.05469 5.75L1.32031 8.51172C0.964844 8.83984 0.964844 9.38672 1.32031 9.71484L1.92188 10.3164C2.25 10.6719 2.79688 10.6719 3.125 10.3164L5.88672 7.58203L8.62109 10.3164C8.94922 10.6719 9.49609 10.6719 9.82422 10.3164L10.4258 9.71484C10.7813 9.38672 10.7813 8.83984 10.4258 8.51172L7.69141 5.75Z"
                fill="#0D0D0E"
            />
        </BaseIcon>
    )
}